export default "__VITE_ASSET__C7SR_ufA__"